import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SignupScreen = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/standouts/login', { replace: true });
  }, [navigate]);
  return null;
};

export default SignupScreen;
